import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import {Modal, notification} from 'ant-design-vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import * as uni from '@/assets/webview.js'


// 创建 axios 实例
const service = axios.create({
  baseURL: '/env', // api base_url
  timeout: 300000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log("------异常响应------",token)
    console.log("------异常响应------",error.response.status)
    switch (error.response.status) {
      case 403:
        notification.error({ message: '系统提示', description: '拒绝访问',duration: 4})
        break
      case 500:
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if(token && data.message=="Token失效，请重新登录"&& window.app_whiteList.indexOf(window.location.pathname) === -1){
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // store.dispatch('Logout').then(() => {
          //     window.location.reload()
          // })
          notification.error({ message: '系统提示', description:'未授权，请重新登录',duration: 4})
          if (token) {
            if(window.app_whiteList.indexOf(window.location.pathname) !== -1){
              uni.reLaunch({
                url: '/pages/login/login?clear=true'
              });
            }else{
              store.dispatch('Logout').then(() => {
                setTimeout(() => {
                  store.dispatch('Logout').then(() => {
                    Vue.ls.remove(ACCESS_TOKEN)
                    window.location.reload()
                  })
                }, 1500)
              })
            }
          }
          // Modal.error({
          //   title: '登录已过期',
          //   content: '很抱歉，登录已过期，请重新登录',
          //   okText: '重新登录',
          //   mask: false,
          //   onOk: () => {
          //     store.dispatch('Logout').then(() => {
          //       Vue.ls.remove(ACCESS_TOKEN)
          //       window.location.reload()
          //     })
          //   }
          // })
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:
          notification.error({ message: '系统提示', description:'很抱歉，资源未找到!',duration: 4})
        break
      case 504:
        notification.error({ message: '系统提示', description: '网络超时'})
        break
      case 401:
        notification.error({ message: '系统提示', description:'未授权，请重新登录',duration: 4})
        if (token) {
          if(window.app_whiteList.indexOf(window.location.pathname) !== -1){
            uni.reLaunch({
              url: '/pages/login/login?clear=true'
            });
          }else{
            store.dispatch('Logout').then(() => {
              setTimeout(() => {
                store.dispatch('Logout').then(() => {
                  Vue.ls.remove(ACCESS_TOKEN)
                  window.location.reload()
                })
              }, 1500)
            })
          }
        }
        break
      default:
        notification.error({
          message: '系统提示',
          description: data.message,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  config.headers = {...config.headers,...store.state.app.requestHeaderParam}
  if(config.method=='get'){
    config.params = {
      _t: Date.parse(new Date())/1000,
      ...config.params
    }
  }
  return config
},(error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    const exportWarning = response.headers && response.headers['x-export-warning']
    if (exportWarning) {
      let description = exportWarning
      try { description = decodeURIComponent(exportWarning) } catch (e) { /* 保留原始提示，避免影响下载。 */ }
      notification.warning({ message: '导出提示', description, duration: 0 })
    }
    if(response.data.hasOwnProperty('code')){
      if(response.data.code==401&&response.data.message!='没有权限，请联系管理员授权'){
        // Vue.prototype.$notification_custom("未授权，请重新登录",'error')
        Vue.prototype.$notification_custom({ message: '系统提示', description:'未授权，请重新登录',duration: 4,type:'error'})
        const token = Vue.ls.get(ACCESS_TOKEN)
        // 判断token   app白名单单独进行跳转处理判断
        if (token) {
          if(window.app_whiteList.indexOf(window.location.pathname) !== -1){
            uni.reLaunch({
              url: '/pages/login/login?clear=true'
            });
          }else{
            store.dispatch('Logout').then(() => {
              setTimeout(() => {
                store.dispatch('Logout').then(() => {
                  Vue.ls.remove(ACCESS_TOKEN)
                  window.location.reload()
                })
              }, 1000)
            })
          }
        }
      }
    }
    return response.data
  }, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
